(() => {
    function initIwtSlider(sectionId) {
        const root = document.getElementById("atlas-iwt-slider-" + sectionId);
        if (!root) return;
        const swiperEl = root.querySelector("swiper-container");
        if (!swiperEl) return;

        function bindForActive() {
            const sw = swiperEl.swiper;
            if (!sw) return;
            // clear previous bindings
            root.querySelectorAll(
                ".custom-prev-button[data-nav-bound], .custom-next-button[data-nav-bound]"
            ).forEach((btn) => {
                if (btn._navHandler)
                    btn.removeEventListener(
                        "click",
                        btn._navHandler
                    );
                btn.removeAttribute("data-nav-bound");
                btn._navHandler = null;
            });
            const active = sw.slides && sw.slides[sw.activeIndex];
            if (!active) return;
            const prev = active.querySelector(
                ".custom-prev-button"
            );
            const next = active.querySelector(
                ".custom-next-button"
            );
            if (prev) {
                prev._navHandler = () => sw.slidePrev();
                prev.addEventListener("click", prev._navHandler);
                prev.setAttribute("data-nav-bound", "");
            }
            if (next) {
                next._navHandler = () => sw.slideNext();
                next.addEventListener("click", next._navHandler);
                next.setAttribute("data-nav-bound", "");
            }

            // --- Arrow disabling logic replacement begins here ---
            // Replace previous updateDisabled logic with improved version
            const setBtnState = (btn, disabled) => {
                if (!btn) return;
                btn.classList.toggle("is-disabled", !!disabled);
                btn.setAttribute(
                    "aria-disabled",
                    disabled ? "true" : "false"
                );
                btn.tabIndex = disabled ? -1 : 0;
                // Force visual + interaction state even без CSS
                btn.style.pointerEvents = disabled ? "none" : "";
                btn.style.opacity = disabled ? "0.4" : "";
                btn.style.visibility = disabled
                    ? "hidden"
                    : "visible";
            };

            const updateDisabled = () => {
                // Ensure Swiper internal flags are fresh
                try {
                    sw.update && sw.update();
                } catch (e) {}
                const isBeginning = sw.isBeginning;
                const isEnd = sw.isEnd;
                setBtnState(prev, isBeginning);
                setBtnState(next, isEnd);
            };

            // run once now
            updateDisabled();
            // and on change
            sw.off("slideChange._atlasNav");
            sw.off("resize._atlasNav");
            sw.off("update._atlasNav");
            sw.off("reachEnd._atlasNav");
            sw.off("reachBeginning._atlasNav");
            sw.off("fromEdge._atlasNav");

            sw.on("slideChange._atlasNav", updateDisabled);
            sw.on("resize._atlasNav", updateDisabled);
            sw.on("update._atlasNav", updateDisabled);
            sw.on("reachEnd._atlasNav", updateDisabled);
            sw.on("reachBeginning._atlasNav", updateDisabled);
            sw.on("fromEdge._atlasNav", updateDisabled);
            // --- Arrow disabling logic replacement ends here ---
        }

        function init() {
            if (!swiperEl.swiper) {
                try {
                    swiperEl.initialize && swiperEl.initialize();
                } catch (e) {}
                // wait a microtask for Swiper to attach
                setTimeout(() => {
                    if (swiperEl.swiper) {
                        bindForActive();
                        swiperEl.swiper.on(
                            "slideChange",
                            bindForActive
                        );
                        swiperEl.swiper.on("resize", bindForActive);
                    }
                }, 0);
            } else {
                bindForActive();
                swiperEl.swiper.on("slideChange", bindForActive);
                swiperEl.swiper.on("resize", bindForActive);
            }
        }

        // Initialize once DOM is ready
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", init, {
                once: true
            });
        } else {
            init();
        }
    }

    // Process any queued section IDs (pushed before this script ran)
    const queue = Array.isArray(window.__atlasIwtSliderQueue) ? window.__atlasIwtSliderQueue : [];
    queue.forEach((id) => initIwtSlider(id));

    // Expose for any IDs pushed after this script ran
    window.__atlasIwtSliderQueue = {
        push: (id) => initIwtSlider(id)
    };
})();
